import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import Breadcrumbs from '@/containers/breadcrumbs'

import Content from '@/components/content'
import PageHeader from '@/components/pageHeader'

import { useSetBreadcrumbs } from '@/state/breadcrumbs'

import QuickLinks from './-components/quickLinks'
import RecentMarkets from './-components/recentMarkets'
import WelcomeBanner from './-components/welcomeBanner'

const dashboardSearchSchema = z.object({
    welcome: z.boolean().optional(),
})

export const Route = createFileRoute('/_authed/$client_code/')({
    component: HomeComponent,
    validateSearch: dashboardSearchSchema,
})

function HomeComponent() {
    const { client_code } = Route.useParams()
    useSetBreadcrumbs([
        {
            text: 'Dashboard',
            to: '/',
        },
    ])
    return (
        <>
            <Breadcrumbs />
            <Content>
                <WelcomeBanner />
                <PageHeader title="Dashboard" />
                <RecentMarkets clientCode={client_code} />
                <QuickLinks clientCode={client_code} />
            </Content>
        </>
    )
}
